import graphql from 'graphql-tag'
import api from '@stores/apollo'

import { IPageInfo, IDMTableDepartment } from '@api'
import { DMTableDepartmentFragment, PageInfoFragment } from '@api/fragments'

export default function list({
  after,
  orderBy,
  first,
  id,
}: {
  after: string | null
  orderBy: string
  first: number
  id: string
}): Promise<{
  teams: IDMTableDepartment[]
  pageInfo: IPageInfo
  counters: { total: number }
}> {
  // ignore snake case
  // eslint-disable-next-line
  return api.gql.query({ query: teamListQuery, variables: { id, after, orderBy, first } }).then(
    ({
      data: {
        node: {
          teamConnection: { edges, pageInfo, counters },
        },
      },
    }: {
      data: {
        node: {
          teamConnection: {
            edges: { node: IDMTableDepartment }[]
            pageInfo: IPageInfo
            counters: { total: number }
          }
        }
      }
    }) => ({ teams: edges.map(({ node }) => node), pageInfo, counters })
  )
}

export const teamListQuery = graphql`
  query TeamList($id: ID!, $after: String, $orderBy: DepartmentOrderByEnum, $first: Int) {
    node(id: $id) {
      ... on Department {
        teamConnection(first: $first, after: $after, orderBy: $orderBy) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...DMTableDepartmentFragment
            }
          }
        }
      }
    }
  }

  ${DMTableDepartmentFragment}
  ${PageInfoFragment}
`
